import { Drawer, List, styled } from '@mui/material';
import { SidebarItem } from './SidebarItem';

const drawerWidth = 240;

const StyledDrawer = styled(Drawer)(({ theme }) => ({
    width: drawerWidth,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: drawerWidth,
    background: theme.palette.background.default,
    borderRight: 'none',
    boxShadow: theme.shadows[4],
    boxSizing: 'border-box',
  },
}));

const menuItems = [
  { text: 'Главная', icon: 'Home', path: '/' },
  { text: 'Видео', icon: 'VideoLibrary', path: '/videos' },
  { text: 'Теги', icon: 'Tag', path: '/tags' },
  { text: 'Авторы', icon: 'People', path: '/authors' },
  // { text: 'Популярное', icon: 'TrendingUp', path: '/popular' },
  { text: 'Поиск', icon: 'Search', path: '/search' },
] as const;

export const Sidebar = ({ mobileOpen, handleDrawerToggle, drawerWidth }: { mobileOpen: boolean; handleDrawerToggle: () => void, drawerWidth: number; }) => {
  return (
    <>
      <StyledDrawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
      >
        <List>
          {menuItems.map((item) => (
            <SidebarItem key={item.text} {...item} />
          ))}
        </List>
      </StyledDrawer>
      <StyledDrawer variant="permanent" open>
        <List>
          {menuItems.map((item) => (
            <SidebarItem key={item.text} {...item} />
          ))}
        </List>
      </StyledDrawer>
    </>
  );
};